var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-card2"},[_vm._m(0),_c('div',{staticClass:"d-chart"},[_c('mr-echarts',{attrs:{"options":_vm.options1}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("累计工作时长")])])
}]

export { render, staticRenderFns }